import { useEffect, useMemo } from "react";

import { useRequest } from "../../../hooks/useRequest";
import routes from "../../../routes";
import { parseProspect } from "../parser";

function useProspectDetails(prospectId: string) {
  const { loading, fetch, response, error } = useRequest();

  useEffect(() => {
    fetch(
      "GET",
      routes.api.prospects.individual({ id: encodeURIComponent(prospectId) }),
    );
  }, [fetch, prospectId]);

  const { prospect, parsingError } = useMemo(() => {
    if (!response?.data || error) {
      return { prospect: null, parsingError: null };
    }

    try {
      return {
        prospect: parseProspect(response.data),
        parsingError: null,
      };
    } catch (parseError) {
      return {
        prospect: null,
        parsingError: Object.assign(
          new Error("This prospect's details could not be read."),
          { cause: parseError },
        ),
      };
    }
  }, [response, error]);

  return {
    loading,
    prospect,
    error: parsingError ?? error,
  };
}

export default useProspectDetails;
